import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import CalendarIcon from 'wix-ui-icons-common/Date';
import Input from '../../Input';
import { formatDate, formatDateV2 } from '../../LocaleUtils';

var DateInput = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(DateInput, _React$PureComponent);

  var _super = _createSuper(DateInput);

  function DateInput() {
    var _this;

    _classCallCheck(this, DateInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_formatDateValue", function () {
      var _this$props = _this.props,
          value = _this$props.value,
          dateFormat = _this$props.dateFormat,
          dateFormatV2 = _this$props.dateFormatV2,
          locale = _this$props.locale;

      if (!value) {
        return '';
      }

      if (dateFormatV2) {
        if (typeof dateFormatV2 === 'function') {
          return dateFormatV2(value);
        }

        return formatDateV2(value, dateFormatV2, locale);
      }

      if (dateFormat) {
        if (typeof dateFormat === 'function') {
          return dateFormat(value);
        }

        return formatDate(value, dateFormat, locale);
      }

      return formatDateV2(value, DateInput.defaultDateFormatV2, locale);
    });

    return _this;
  }

  _createClass(DateInput, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          initialValue = _this$props2.value,
          customInput = _this$props2.customInput,
          rest = _objectWithoutProperties(_this$props2, ["value", "customInput"]);

      var _inputProps = _objectSpread(_objectSpread({
        value: this._formatDateValue(),
        prefix: /*#__PURE__*/React.createElement(Input.IconAffix, {
          dataHook: "date-input-date-icon"
        }, /*#__PURE__*/React.createElement(CalendarIcon, null)),
        autoSelect: false
      }, rest), customInput ? customInput.props : {});

      return /*#__PURE__*/React.cloneElement(customInput || /*#__PURE__*/React.createElement(Input, null), _inputProps);
    }
  }]);

  return DateInput;
}(React.PureComponent);

_defineProperty(DateInput, "displayName", 'DateInput');

_defineProperty(DateInput, "defaultProps", {
  locale: 'en'
});

_defineProperty(DateInput, "defaultDateFormatV2", 'LL/dd/yyyy');

DateInput.propTypes = _objectSpread(_objectSpread({}, Input.propTypes), {}, {
  /** The selected date */
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.number]),

  /** Instance locale */
  locale: PropTypes.oneOfType([PropTypes.oneOf(['en', 'es', 'pt', 'fr', 'de', 'pl', 'it', 'ru', 'ja', 'ko', 'tr', 'sv', 'no', 'nl', 'da']), PropTypes.shape({
    distanceInWords: PropTypes.object,
    format: PropTypes.object
  })]),

  /** this prop is deprecated and should not be used
   * @deprecated
   */
  dateFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),

  /** Custom date format V2, can be either:
   * * `string` of tokens (see [`date-fns V2` docs](https://date-fns.org/v2.15.0/docs/format) for list of supported tokens)
   * * `function` of signature `Date -> String`
   */
  dateFormatV2: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
});
export default DateInput;